"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/popover/popover-arrow-path.ts
var POPOVER_ARROW_PATH = "M23 27.8C24.1 29 26.4 30 28 30H30H0H2C3.7 30 5.9 29 7 27.8L14 20.6C14.7 19.8 15.3 19.8 16 20.6L23 27.8Z";



exports.POPOVER_ARROW_PATH = POPOVER_ARROW_PATH;
